export interface Drama {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  episodes: number;
  status: string;
  director: string;
  actors: string[];
  description: string;
  coverImage: string;
  heroImage: string;
  updateInfo: string;
  featured: boolean;
  rank: number;
  slug: string;
  tags: string[];
}

export const dramas: Drama[] = [
  {
    id: 1,
    title: "狂飙",
    category: "悬疑剧",
    categorySlug: "xuanyi",
    year: 2023,
    rating: 9.1,
    episodes: 39,
    status: "已完结",
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐", "张志坚", "吴刚"],
    description: "京海市一线刑警安欣在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合公检法司各部门，清除了政法队伍内部的腐败分子，粉碎了黑恶势力的保护伞。",
    coverImage: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20style%20with%20warm%20amber%20and%20deep%20red%20lighting%2C%20noir%20atmosphere%20with%20dramatic%20shadows%2C%20two%20figures%20in%20silhouette%20facing%20each%20other%20on%20dark%20street%2C%20rain%20slicked%20pavement%20reflecting%20neon%20glow%2C%20intense%20confrontation%20mood%2C%20premium%20tv%20series%20poster%20aesthetic%2C%20cinematic%20composition%20with%20film%20grain%20texture&width=600&height=800&seq=drama-cover-01&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20atmospheric%20scene%20with%20dark%20urban%20street%20at%20night%2C%20soft%20golden%20street%20lights%20reflecting%20on%20wet%20pavement%2C%20dramatic%20film%20noir%20lighting%20with%20deep%20shadows%2C%20mysterious%20and%20intense%20mood%2C%20luxurious%20cinema%20color%20grading%20with%20warm%20amber%20and%20coral%20tones%2C%20abstract%20urban%20backdrop%20with%20bokeh%20lights&width=1600&height=900&seq=drama-hero-01&orientation=landscape",
    updateInfo: "全39集",
    featured: true,
    rank: 1,
    slug: "kuangbiao",
    tags: ["热门", "高分", "悬疑"]
  },
  {
    id: 2,
    title: "漫长的季节",
    category: "悬疑剧",
    categorySlug: "xuanyi",
    year: 2023,
    rating: 9.4,
    episodes: 12,
    status: "已完结",
    director: "辛爽",
    actors: ["范伟", "秦昊", "陈明昊", "李庚希"],
    description: "出租车司机王响和妹夫龚彪在调查套牌车的过程中，发现了一个与多年前碎尸悬案有关的线索。随着调查的深入，一段跨越二十年的往事逐渐浮出水面，三人组的命运也由此改变。",
    coverImage: "https://readdy.ai/api/search-image?query=Autumnal%20cinematic%20poster%20with%20golden%20fall%20leaves%20scattered%20on%20old%20factory%20ground%2C%20warm%20nostalgic%20amber%20tone%2C%20three%20middle%20aged%20men%20figures%20in%20distance%20silhouette%2C%20vintage%201990s%20northeast%20China%20industrial%20aesthetic%2C%20melancholic%20yet%20warm%20atmosphere%2C%20premium%20drama%20series%20art%20poster%20design&width=600&height=800&seq=drama-cover-02&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Warm%20autumn%20landscape%20with%20golden%20sunlight%20filtering%20through%20old%20trees%2C%20rusty%20industrial%20factory%20in%20background%2C%20nostalgic%201990s%20northeast%20China%20vibe%2C%20soft%20warm%20color%20palette%20with%20amber%20and%20russet%20tones%2C%20cinematic%20wide%20shot%20with%20shallow%20depth%20of%20field%2C%20melancholic%20beautiful%20atmosphere&width=1600&height=900&seq=drama-hero-02&orientation=landscape",
    updateInfo: "全12集",
    featured: true,
    rank: 2,
    slug: "manchangdejijie",
    tags: ["高分", "口碑", "悬疑"]
  },
  {
    id: 3,
    title: "庆余年",
    category: "古装剧",
    categorySlug: "guzhuang",
    year: 2019,
    rating: 8.0,
    episodes: 46,
    status: "已完结",
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明", "吴刚", "辛芷蕾"],
    description: "一个身世神秘的少年范闲，自小跟随奶奶生活在海边小城澹州。在一位神秘老师的教导下，他熟识药性药理，修炼霸道真气并精进武艺。为了解开身世之谜，他前往京都，历经家族、江湖、庙堂的种种考验与锤炼。",
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20costume%20drama%20poster%20with%20flowing%20hanfu%20robes%20in%20deep%20burgundy%20and%20gold%2C%20figure%20holding%20ancient%20sword%20on%20palace%20rooftop%20at%20sunset%2C%20dramatic%20clouds%20and%20warm%20golden%20sky%2C%20cinematic%20wuxia%20aesthetic%20with%20flowing%20silk%20fabric%2C%20premium%20historical%20fantasy%20drama%20poster%20design&width=600&height=800&seq=drama-cover-03&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Magnificent%20ancient%20Chinese%20palace%20silhouette%20at%20golden%20sunset%2C%20layered%20rooftops%20with%20curved%20eaves%2C%20dramatic%20clouds%20painted%20in%20warm%20coral%20and%20amber%20hues%2C%20misty%20mountains%20in%20far%20distance%2C%20cinematic%20epic%20fantasy%20atmosphere%2C%20rich%20warm%20color%20grading%20with%20film%20texture&width=1600&height=900&seq=drama-hero-03&orientation=landscape",
    updateInfo: "全46集",
    featured: true,
    rank: 3,
    slug: "qingyunian",
    tags: ["热门", "古装", "权谋"]
  },
  {
    id: 4,
    title: "三体",
    category: "科幻剧",
    categorySlug: "kehuan",
    year: 2023,
    rating: 8.7,
    episodes: 30,
    status: "已完结",
    director: "杨磊",
    actors: ["张鲁一", "于和伟", "陈瑾", "王子文", "林永健"],
    description: "2007年，地球基础科学出现了异常的扰动，一时间科学界风雨飘飘，人心惶惶。离奇自杀的科学家，近乎神迹的倒计时，行事隐秘的科学边界，神秘莫测的《三体》游戏。纳米科学家汪淼被警官史强带到联合作战中心，潜入「科学边界」组织协助调查。",
    coverImage: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20drama%20poster%20with%20cosmic%20background%2C%20three%20suns%20in%20strange%20alignment%20in%20deep%20space%2C%20mysterious%20geometric%20alien%20signal%20pattern%2C%20dark%20blue-black%20cosmos%20with%20warm%20orange%20accent%20light%2C%20intellectual%20hard%20sci-fi%20aesthetic%2C%20premium%20series%20poster%20with%20minimalist%20design&width=600&height=800&seq=drama-cover-04&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Deep%20space%20cosmic%20landscape%20with%20galaxy%20spiral%20and%20nebula%20clouds%20in%20warm%20amber%20and%20coral%20tones%2C%20vast%20starfield%20with%20mysterious%20light%20phenomenon%2C%20contemplative%20sci-fi%20atmosphere%2C%20radio%20telescope%20array%20silhouette%20on%20horizon%2C%20cinematic%20widescreen%20composition%20with%20rich%20color%20depth&width=1600&height=900&seq=drama-hero-04&orientation=landscape",
    updateInfo: "全30集",
    featured: false,
    rank: 4,
    slug: "santi",
    tags: ["科幻", "高分", "悬疑"]
  },
  {
    id: 5,
    title: "繁花",
    category: "都市剧",
    categorySlug: "dushi",
    year: 2023,
    rating: 8.9,
    episodes: 30,
    status: "已完结",
    director: "王家卫",
    actors: ["胡歌", "马伊琍", "唐嫣", "辛芷蕾"],
    description: "九十年代的上海，处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼，跻身成为商界后起之秀。黄河路上车水马龙，人人争上游，道尽一个时代的情义与至真。",
    coverImage: "https://readdy.ai/api/search-image?query=Artistic%201990s%20Shanghai%20neon%20night%20drama%20poster%2C%20elegant%20figure%20in%20vintage%20suit%20walking%20on%20rain-slicked%20street%20with%20colorful%20neon%20signs%20reflecting%2C%20warm%20golden%20and%20coral%20lighting%2C%20nostalgic%20romance%20atmosphere%2C%20Wong%20Kar-wai%20inspired%20cinematic%20aesthetic%20with%20soft%20bokeh%2C%20premium%20drama%20poster&width=600&height=800&seq=drama-cover-05&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Nostalgic%201990s%20Shanghai%20cityscape%20at%20dusk%20with%20neon%20lights%20reflecting%20on%20Huangpu%20River%2C%20warm%20golden%20hour%20glow%20over%20the%20Bund%2C%20vintage%20cars%20and%20bustling%20street%20life%2C%20cinematic%20color%20palette%20with%20amber%20and%20soft%20coral%20tones%2C%20romantic%20retro%20atmosphere%20with%20film%20grain%20texture&width=1600&height=900&seq=drama-hero-05&orientation=landscape",
    updateInfo: "全30集",
    featured: false,
    rank: 5,
    slug: "fanhua",
    tags: ["热门", "年代", "剧情"]
  },
  {
    id: 6,
    title: "莲花楼",
    category: "古装剧",
    categorySlug: "guzhuang",
    year: 2023,
    rating: 8.5,
    episodes: 40,
    status: "已完结",
    director: "郭虎",
    actors: ["成毅", "曾舜晞", "肖顺尧", "陈都灵"],
    description: "十年前四顾门门主李相夷以相夷太剑冠绝天下，为正道武林之光，却因与金鸳盟盟主笛飞声约战东海而双双下落不明。十年后李莲花拖着一座莲花楼行医问世，误打误撞得了个神医的名头。",
    coverImage: "https://readdy.ai/api/search-image?query=Martial%20arts%20ancient%20Chinese%20drama%20poster%20with%20floating%20lotus%20flowers%20on%20misty%20lake%2C%20figure%20in%20white%20hanfu%20standing%20on%20wooden%20pavilion%2C%20ethereal%20morning%20light%20with%20soft%20golden%20and%20pink%20tones%2C%20poetic%20wuxia%20atmosphere%2C%20dreamy%20watercolor%20style%20aesthetic%2C%20elegant%20premium%20drama%20poster&width=600&height=800&seq=drama-cover-06&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Serene%20ancient%20Chinese%20lake%20landscape%20with%20lotus%20blooms%20at%20sunrise%2C%20misty%20mountains%20in%20background%2C%20wooden%20pavilion%20reflected%20on%20still%20water%2C%20soft%20warm%20morning%20light%20with%20golden%20and%20coral%20hues%2C%20dreamy%20ethereal%20atmosphere%2C%20cinematic%20widescreen%20composition&width=1600&height=900&seq=drama-hero-06&orientation=landscape",
    updateInfo: "全40集",
    featured: false,
    rank: 6,
    slug: "lianhualou",
    tags: ["古装", "武侠", "探案"]
  },
  {
    id: 7,
    title: "去有风的地方",
    category: "都市剧",
    categorySlug: "dushi",
    year: 2023,
    rating: 8.7,
    episodes: 40,
    status: "已完结",
    director: "丁梓光",
    actors: ["刘亦菲", "李现", "胡冰卿", "牛骏峰"],
    description: "许红豆因为闺蜜去世，生活和工作陷入低谷，独自前往大理云苗村散心。在那里，她遇到了辞去高薪工作回乡创业的谢之遥，和一群从大城市来的同龄人。在日常相处中，他们互相温暖、彼此治愈。",
    coverImage: "https://readdy.ai/api/search-image?query=Romantic%20drama%20poster%20with%20couple%20figures%20walking%20in%20scenic%20Dali%20countryside%20with%20wind-swept%20grassland%2C%20warm%20sunset%20golden%20light%2C%20traditional%20Bai%20architecture%20in%20distance%2C%20healing%20slice-of-life%20aesthetic%2C%20soft%20pastel%20warm%20tones%2C%20premium%20romance%20drama%20poster%20design&width=600&height=800&seq=drama-cover-07&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Beautiful%20Dali%20Yunnan%20countryside%20landscape%20at%20golden%20hour%2C%20rolling%20green%20hills%20with%20wildflowers%2C%20traditional%20white%20buildings%20with%20Erhai%20Lake%20in%20distance%2C%20dramatic%20warm%20sunset%20sky%20with%20coral%20and%20amber%20clouds%2C%20peaceful%20healing%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=drama-hero-07&orientation=landscape",
    updateInfo: "全40集",
    featured: false,
    rank: 7,
    slug: "quyoufengdedifang",
    tags: ["治愈", "爱情", "田园"]
  },
  {
    id: 8,
    title: "山河令",
    category: "古装剧",
    categorySlug: "guzhuang",
    year: 2021,
    rating: 8.6,
    episodes: 36,
    status: "已完结",
    director: "成志超",
    actors: ["龚俊", "张哲瀚", "周也", "马闻远"],
    description: "天窗首领周子舒为求自由，不惜以生命为代价退出组织。在江湖游历中，他遇到了温客行，两人卷入江湖纷争，在相互救赎中寻找各自的归途。",
    coverImage: "https://readdy.ai/api/search-image?query=Wuxia%20ancient%20Chinese%20drama%20poster%20with%20two%20figures%20in%20flowing%20robes%20facing%20each%20other%20on%20mountain%20peak%2C%20dramatic%20clouds%20and%20mist%20surrounding%20them%2C%20warm%20sunset%20light%20from%20behind%2C%20poetic%20martial%20arts%20romance%20aesthetic%2C%20elegant%20ink%20wash%20painting%20style%2C%20premium%20drama%20poster&width=600&height=800&seq=drama-cover-08&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Epic%20mountain%20peak%20landscape%20with%20sea%20of%20clouds%20at%20sunset%2C%20dramatic%20warm%20golden%20and%20coral%20sky%2C%20misty%20valleys%20between%20jagged%20peaks%2C%20ancient%20Chinese%20ink%20painting%20aesthetic%2C%20two%20distant%20figures%20on%20peak%2C%20cinematic%20epic%20wuxia%20atmosphere%20with%20rich%20color%20depth&width=1600&height=900&seq=drama-hero-08&orientation=landscape",
    updateInfo: "全36集",
    featured: false,
    rank: 8,
    slug: "shanheling",
    tags: ["古装", "武侠", "江湖"]
  },
  {
    id: 9,
    title: "隐秘的角落",
    category: "悬疑剧",
    categorySlug: "xuanyi",
    year: 2020,
    rating: 8.8,
    episodes: 12,
    status: "已完结",
    director: "辛爽",
    actors: ["秦昊", "王景春", "荣梓杉", "史彭元"],
    description: "沿海小城的三个孩子在景区游玩时，无意拍摄记录了一次谋杀，他们的冒险也由此展开。扑朔迷离的案情，将几个家庭裹挟其中，带向不可预知的未来。",
    coverImage: "https://readdy.ai/api/search-image?query=Suspense%20thriller%20drama%20poster%20with%20three%20children%20silhouettes%20standing%20on%20old%20rooftop%20overlooking%20coastal%20town%20at%20dusk%2C%20ominous%20warm%20amber%20sky%2C%20dark%20shadows%20and%20mysterious%20atmosphere%2C%20psychological%20thriller%20aesthetic%2C%20premium%20series%20poster%20with%20film%20noir%20lighting&width=600&height=800&seq=drama-cover-09&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Coastal%20Chinese%20small%20town%20at%20twilight%20with%20fishing%20boats%20and%20old%20buildings%2C%20dramatic%20orange%20and%20amber%20sunset%20sky%2C%20narrow%20alleys%20with%20mysterious%20shadows%2C%20atmospheric%20film%20noir%20lighting%2C%20sense%20of%20hidden%20secrets%20and%20impending%20danger%2C%20cinematic%20wide%20composition&width=1600&height=900&seq=drama-hero-09&orientation=landscape",
    updateInfo: "全12集",
    featured: false,
    rank: 9,
    slug: "yinmidejiaoluo",
    tags: ["悬疑", "高分", "犯罪"]
  },
  {
    id: 10,
    title: "陈情令",
    category: "古装剧",
    categorySlug: "guzhuang",
    year: 2019,
    rating: 7.7,
    episodes: 50,
    status: "已完结",
    director: "郑伟文",
    actors: ["肖战", "王一博", "孟子义", "宣璐"],
    description: "十六年前，天下五分，姑苏蓝氏、云梦江氏、清河聂氏、岐山温氏、兰陵金氏共治天下。温氏一家独大，其余四家均受其苦。众家青年中，江氏故人之子魏无羡性格开朗，和以雅正闻名的蓝忘机相识并引为知己。",
    coverImage: "https://readdy.ai/api/search-image?query=Fantasy%20ancient%20Chinese%20drama%20poster%20with%20flute%20player%20in%20black%20robes%20and%20swordsman%20in%20white%20on%20cliff%20edge%2C%20moonlit%20night%20sky%20with%20floating%20spirit%20energy%2C%20dramatic%20ink%20wash%20style%20with%20warm%20silver%20and%20coral%20accents%2C%20elegant%20xianxia%20aesthetic%2C%20premium%20drama%20poster&width=600&height=800&seq=drama-cover-10&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mountain%20temple%20landscape%20under%20full%20moon%2C%20cherry%20blossoms%20in%20bloom%2C%20misty%20valley%20with%20waterfall%2C%20ethereal%20silver%20moonlight%20with%20warm%20coral%20atmosphere%2C%20fantasy%20xianxia%20world%2C%20dreamy%20romantic%20cinematic%20wide%20shot%20with%20soft%20glow&width=1600&height=900&seq=drama-hero-10&orientation=landscape",
    updateInfo: "全50集",
    featured: false,
    rank: 10,
    slug: "chenqingling",
    tags: ["古装", "仙侠", "耽改"]
  },
  {
    id: 11,
    title: "警察荣誉",
    category: "都市剧",
    categorySlug: "dushi",
    year: 2022,
    rating: 8.5,
    episodes: 38,
    status: "已完结",
    director: "丁黑",
    actors: ["张若昀", "白鹿", "王景春", "宁理"],
    description: "四位见习警员在「警情高发」的平陵市八里河派出所，历经各类案件洗礼，在老警察的言传身教下迅速成长，最终成为合格的人民警察的故事。",
    coverImage: "https://readdy.ai/api/search-image?query=Police%20drama%20poster%20with%20four%20young%20officers%20in%20uniform%20standing%20in%20front%20of%20police%20station%2C%20warm%20sunset%20light%20casting%20long%20shadows%2C%20urban%20Chinese%20city%20backdrop%2C%20slice-of-life%20realistic%20aesthetic%2C%20warm%20golden%20tone%2C%20premium%20drama%20series%20poster&width=600&height=800&seq=drama-cover-11&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Bustling%20Chinese%20city%20neighborhood%20at%20sunset%20with%20small%20police%20station%2C%20warm%20golden%20light%20on%20residential%20buildings%2C%20local%20shop%20signs%20and%20street%20vendors%2C%20realistic%20urban%20slice-of-life%20scenery%2C%20cinematic%20cityscape%20with%20amber%20and%20warm%20coral%20tones%2C%20grounded%20humanistic%20atmosphere&width=1600&height=900&seq=drama-hero-11&orientation=landscape",
    updateInfo: "全38集",
    featured: false,
    rank: 11,
    slug: "jingcharongyu",
    tags: ["现实", "职场", "温情"]
  },
  {
    id: 12,
    title: "苍兰诀",
    category: "古装剧",
    categorySlug: "guzhuang",
    year: 2022,
    rating: 8.1,
    episodes: 36,
    status: "已完结",
    director: "伊峥",
    actors: ["虞书欣", "王鹤棣", "徐海乔", "郭晓婷"],
    description: "魄心族神女被魔尊东方青苍灭族，万年后重生成天界低阶仙女小兰花。无意间复活了困于昊天塔的灭族仇人魔尊。为获得自由，东方青苍要牺牲小兰花的神女之魂解开身上咒术封印。",
    coverImage: "https://readdy.ai/api/search-image?query=Xianxia%20fantasy%20romance%20drama%20poster%20with%20heavenly%20palace%20and%20floating%20islands%2C%20couple%20figures%20in%20flowing%20celestial%20robes%2C%20magic%20spirit%20energy%20in%20warm%20golden%20and%20coral%20colors%2C%20dreamy%20ethereal%20atmosphere%20with%20cherry%20blossom%20petals%2C%20romantic%20fantasy%20aesthetic%2C%20premium%20drama%20poster&width=600&height=800&seq=drama-cover-12&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=Heavenly%20fantasy%20palace%20floating%20among%20clouds%20at%20sunrise%2C%20golden%20and%20coral%20sky%20with%20divine%20light%20rays%2C%20ethereal%20cloud%20sea%20with%20floating%20islands%2C%20ancient%20Chinese%20celestial%20architecture%2C%20dreamy%20romantic%20xianxia%20atmosphere%2C%20cinematic%20epic%20wide%20shot&width=1600&height=900&seq=drama-hero-12&orientation=landscape",
    updateInfo: "全36集",
    featured: false,
    rank: 12,
    slug: "canglanjue",
    tags: ["古装", "仙侠", "爱情"]
  }
];

export const hotRanking = dramas.filter(d => d.rank <= 10).sort((a, b) => a.rank - b.rank);

export const featuredDramas = dramas.filter(d => d.featured);

export function getDramasByCategory(categorySlug: string): Drama[] {
  return dramas.filter(d => d.categorySlug === categorySlug);
}

export function getDramaBySlug(slug: string): Drama | undefined {
  return dramas.find(d => d.slug === slug);
}

export function getRelatedDramas(drama: Drama, count: number = 4): Drama[] {
  return dramas
    .filter(d => d.id !== drama.id && d.categorySlug === drama.categorySlug)
    .slice(0, count);
}